import { render } from "./Universo.vue?vue&type=template&id=4564a76b"
import script from "./Universo.vue?vue&type=script&lang=js"
export * from "./Universo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__